<template>
  <el-dialog :visible.sync="visible" title="图表数据" width="60%">
    <ve-histogram :settings="chartSettings"  :data="chartData"></ve-histogram>
  </el-dialog>
</template>

<script>
  import bus from "./bus"
  export default {
    name: "viewChatrs",
    data(){
      this.chartSettings = {
        stack: { '案例': ['案例数量', '百分占比'] }
      }
      return{
        visible:false,
        chartData:{
          columns: ['title', '案例数量','百分占比'],
          rows: [],
        }
      }
    },
    methods:{
    },
    mounted() {
      bus.$on("view",(bool)=>{
        this.visible = bool;
      });
      bus.$on('vData',(row)=>{
        this.chartData.rows =row;
      })
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/statistics/viewChatrs.vue